import React from "react";
import {RemoveIcon} from "../../../../../../../../components/ui/RemoveIcon";
import {Link} from "react-router-dom";
import LordIcon from "../../../../../../../../components/ui/LordIcon";
import {Colors} from "../../../../../../../../components/theme";
import {useTranslation} from "react-i18next";

export default function CooperationWith({dataset, dispatch}) {
    const {t} = useTranslation();

    const viewData = () => {
        const view_list = dataset.map((item, index) => {
            return (
                <div key={item.pk} className="py-1">
                    <div
                        className='customSelectParent'
                        style={{position: "relative"}}>

                            {index+1}. {item.name}

                            <RemoveIcon
                                className='fa fa-times'
                                style={{position: 'relative', top: '0px', height: '20px', width: '20px', fontSize:'12px', padding: '3px 5px 3px 5px'}}
                                onClick={() => dispatch({
                                    type: 'REMOVE_COOPERATION_WITH',
                                    pk: item.pk
                                })}
                            />
                    </div>
                </div>
            )}
        )
        return dataset.length > 0 ? view_list : <div className="py-2 ps-1">{t("common.titles.to_define")}</div>
    }

    return (<>
        {viewData()}
        <div className="mt-2">
            <Link className="addGroup" to={""} onClick={() => dispatch({type: "CREATE_POPUP_COOPERATION"})}>
                <LordIcon url='cross' color={`${Colors.red};`} rotate='45' target='.addGroup'/>
                <span className="ps-2">{t("common.button.add")}</span>
            </Link>
        </div>
    </>)
}